import type { Money } from "./types";

const currencyFormatters = new Map<string, Intl.NumberFormat>();

function getFormatter(currencyCode: string) {
  const cached = currencyFormatters.get(currencyCode);
  if (cached) return cached;
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 2,
  });
  currencyFormatters.set(currencyCode, formatter);
  return formatter;
}

export function formatMoney(money: Money | null | undefined): string {
  if (!money) return "";
  const amount = Number(money.amount);
  if (Number.isNaN(amount)) return "";
  return getFormatter(money.currencyCode).format(amount);
}

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

export function multiplyMoney(money: Money, quantity: number): Money {
  const amount = (Number(money.amount) * quantity).toFixed(2);
  return { amount, currencyCode: money.currencyCode };
}

export function sumMoney(items: Money[]): Money {
  if (items.length === 0) return { amount: "0.00", currencyCode: "GBP" };
  const currencyCode = items[0].currencyCode;
  const total = items.reduce((acc, m) => acc + Number(m.amount), 0).toFixed(2);
  return { amount: total, currencyCode };
}
